import { useState } from "react";
import { Edit2Icon, Trash2Icon, MoreHorizontalIcon } from "@gfg/ui/icons";
import { createUseStyles } from "@gfg/ui/theming";
import { IconButton } from "@gfg/ui/components/button";
import { SearchOptimizationState } from "@coral/typings";
import ActionCellWithIcons from "~/common/components/table/cells/action-cell";
import DeleteModal from "~/common/components/delete-modal";
import DropdownActionButton, { AvailableOption } from "~/common/components/buttons/dropdown-action-button";

const useStyles = createUseStyles(({ colors, size }) => ({
  icon: {
    background: colors.lightersecondary,
  },
  iconButton: {
    margin: size(5),
  },
}));

interface ActionCellProps {
  onDelete(): void;
  onEdit(): void;
  onStateChange(newState: SearchOptimizationState): void;
}

const dropdownOptions: AvailableOption<SearchOptimizationState>[] = [
  {
    label: "Enable",
    value: "Enabled",
  },
  {
    label: "Reject",
    value: "Disabled",
  },
  {
    label: "Pending",
    value: "Pending",
  },
];

export default function ActionCell({ onDelete, onEdit, onStateChange }: ActionCellProps) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <ActionCellWithIcons>
        <DropdownActionButton
          triggerElement={<IconButton icon={MoreHorizontalIcon} round variant="light" className={classes.icon} />}
          options={dropdownOptions}
          onOptionClick={value => onStateChange(value as SearchOptimizationState)}
        />
        <IconButton onClick={onEdit} icon={Edit2Icon} round variant="light" className={classes.icon} />
        <IconButton onClick={() => setOpen(true)} icon={Trash2Icon} round variant="light" className={classes.icon} />
      </ActionCellWithIcons>
      <DeleteModal
        open={open}
        title="Delete Optimization"
        text="Are you sure you want to delete this optimization?"
        onToggle={setOpen}
        onDelete={onDelete}
      />
    </>
  );
}
